import {PayloadAction, createSlice} from '@reduxjs/toolkit';
export interface ICropedProductImage {
  imageFile: File | null;
}

interface IImage {
  imageFile: File | null;
}

const initialState: ICropedProductImage = {
  imageFile: null,
};

export const productImageSlice = createSlice({
  name: 'productImage',
  initialState,
  reducers: {
    addImage: (state, action: PayloadAction<any>) => {
      state.imageFile = action.payload.imageFile;
    },
  },
});

export const {addImage} = productImageSlice.actions;
export default productImageSlice.reducer;
